import axios from "axios";
import { KeyboardEvent, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import OAuthBar from "../components/auth/OAuthBar";
import { KTRLogo } from "../components/shared/ktr";
import { useAuth } from "../hooks/useAuth";

type LocationProps = {
  state: {
    from: Location;
  };
};

export default function Login() {
  const { login, isAuthenticated, user } = useAuth();
  let navigate = useNavigate();
  let location = useLocation() as LocationProps;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      if (location.state && location.state.from) {
        console.log(`navigating to ${location.state.from.pathname}`);
        navigate(location.state.from.pathname, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  });

  async function loginEmail() {
    try {
      const success = await login({ email, password });
      if (success) {
        toast.success("Login successful");
        // navigate(from, { replace: true });
      } else {
        toast.error("Error on signin");
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error(
          "Something really went wrong, you might want to contact support!"
        );
      }
    }
  }

  function handleEnter(event: KeyboardEvent) {
    if (event.key === "Enter") {
      loginEmail();
    }
  }

  return (
    <div className="flex flex-grow mt-20">
      <div className="flex flex-col items-center w-full">
        <div className="flex flex-col items-center">
          <div className="h-40 w-40">
            <KTRLogo />
          </div>
          {/* <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Login
          </h2> */}
        </div>
        <div className="mt-8 shadow px-8 py-8 pt-1 rounded-md bg-white w-full max-w-md">
          <div className="rounded-md shadow-sm space-y-5 mt-6">
            <div>
              <label
                htmlFor="email-address"
                className="block text-sm font-medium text-gray-700"
              >
                Email address
              </label>
              <div className="mt-1">
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 focus:z-10 sm:text-sm"
                  placeholder=""
                  onChange={(email) => setEmail(email.target.value)}
                  defaultValue={email}
                  onKeyDown={handleEnter}
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Password
              </label>
              <div className="mt-1">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red-500 focus:border-red-500 focus:z-10 sm:text-sm"
                  placeholder=""
                  onChange={(password) => setPassword(password.target.value)}
                  defaultValue={password}
                  onKeyDown={handleEnter}
                />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between mt-6">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
              />
              <label
                htmlFor="remember-me"
                className="ml-2 block text-sm text-gray-900"
              >
                Remember me
              </label>
            </div>

            <div className="text-sm">
              <Link
                className="font-medium text-red-600 hover:text-red-500"
                to="/resetPassword"
              >
                Forgot your password?
              </Link>
            </div>
          </div>

          <div className="mt-6">
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              onClick={() => loginEmail()}
            >
              Sign in
            </button>
          </div>
          <div className="divider mt-2">
            <span className="block text-sm text-gray-500 text-center divider-text font-light">
              Or continue with
            </span>
          </div>
          <OAuthBar />
        </div>
      </div>
    </div>
  );
}
